/* src/app/modules/shared/components/column/column-name/column-name.component.scss */
app-column-name {
  display: contents;
}
app-column-name div.subtitle-flex-container {
  gap: 0.5rem;
  align-items: center;
}
/*# sourceMappingURL=column-name.component.css.map */
